import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconNoSearchResult158px = _resolveComponent("IconNoSearchResult158px")!
  const _component_IconNoSearchResult103px = _resolveComponent("IconNoSearchResult103px")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createBlock(_component_IconBase, {
    width: _ctx.iconSize,
    height: _ctx.iconHeight[_ctx.iconSize],
    "view-box": `0 0 ${_ctx.iconSize} ${_ctx.iconHeight[_ctx.iconSize]}`,
    "icon-color": "transparent"
  }, {
    default: _withCtx(() => [
      (_ctx.iconSize === 158)
        ? (_openBlock(), _createBlock(_component_IconNoSearchResult158px, {
            key: 0,
            "icon-color": _ctx.iconColor
          }, null, 8, ["icon-color"]))
        : (_ctx.iconSize === 103)
          ? (_openBlock(), _createBlock(_component_IconNoSearchResult103px, {
              key: 1,
              "icon-color": _ctx.iconColor
            }, null, 8, ["icon-color"]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["width", "height", "view-box"]))
}